import {useCopyToClipboard} from '@/shared/hooks/use-copy-to-clipboard'
import {IconButton, IconButtonProps} from '@chakra-ui/react'
import {Tooltip} from '@cypro/ui/components/ui/tooltip'
import {useTranslate} from '@tolgee/react'
import {LuCheck, LuCopy} from 'react-icons/lu'

interface Props extends IconButtonProps {
  value: string
}

export function CopyButton({value, ...props}: Props) {
  const {t} = useTranslate('common')
  const {copied, copy} = useCopyToClipboard()

  return (
    <Tooltip content={copied ? t('copied') : t('click_to_copy_id')}>
      <IconButton
        size="xs"
        variant="ghost"
        aria-label={t('click_to_copy_id')}
        {...props}
        onClick={() => void copy(value)}
      >
        {copied ? <LuCheck /> : <LuCopy />}
      </IconButton>
    </Tooltip>
  )
}
